export default [
  {
    path: '/admin/product-groups',
    name: 'product-group',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product/group')
  }
]